import { useContext, useEffect, useMemo } from "react";
import apiClient from "./apiClient";
import { AppContext } from "../context/AppContext";

export const useApiClient = () => {
  const { token } = useContext(AppContext);

  useEffect(() => {
    const id = apiClient.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;
      else delete config.headers.Authorization;
      return config;
    });

    return () => apiClient.interceptors.request.eject(id);
  }, [token]);

  const ensureUrl = (url) => {
    const u = String(url ?? "").trim();
    if (!u || u === "undefined" || u === "null" || u.includes("undefined") || u.includes("null")) {
      throw new Error(`Blocked request: invalid url "${u}"`);
    }
    return u;
  };

  return useMemo(
    () => ({
      get: (url, params) => apiClient.get(ensureUrl(url), { params }),
      post: (url, data) => apiClient.post(ensureUrl(url), data),
      put: (url, data) => apiClient.put(ensureUrl(url), data),
      delete: (url, data) => apiClient.delete(ensureUrl(url), { data }),
    }),
    []
  );
};



// import { useContext, useEffect, useMemo } from "react";
// import apiClient from "./apiClient";
// import { AppContext } from "../context/AppContext";

// export const useApiClient = () => {
//   const { token } = useContext(AppContext);

//   useEffect(() => {
//     const id = apiClient.interceptors.request.use((config) => {
//       if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//       } else {
//         delete config.headers.Authorization;
//       }
//       return config;
//     });

//     return () => apiClient.interceptors.request.eject(id);
//   }, [token]);

// const ensureUrl = (url) => {
//   if (!url || url === "undefined" || url === "null" || String(url).includes("undefined")) {
//     throw new Error(`Blocked request: invalid url "${url}"`);
//   }
//   return url;
// };

//   return useMemo(
//     () => ({
//       get: (url, params) => apiClient.get(url, { params }),
//       post: (url, data) => apiClient.post(url, data),
//       put: (url, data) => apiClient.put(url, data),
//       delete: (url, data) => apiClient.delete(url, { data }),
//     }),
//     []
//   );
// };
